<template>
  <TroodonNav>404</TroodonNav>
  <TroodonMain>
    <div class="c-error c-error--404">
      <h2 class="c-error__title">お探しのページが見つかりませんでした。</h2>
      <div class="c-error__note">
        <p class="c-error__note-label">考えられるケース</p>
        <ul class="c-error__note-list">
          <li>URLが間違っている</li>
          <li>ご家族宛に送られたURLにアクセスしている</li>
        </ul>
      </div>
    </div>
  </TroodonMain>
</template>

<script setup lang="ts">
import '~/styles/troodon/_variables.scss'
import type { NuxtError } from '#app'
import TroodonMain from '~/components/troodon/troodon-main.vue'
import TroodonNav from '~/components/troodon/troodon-nav.vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
.c-error {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px 0;
  text-align: center;
}

.c-error__title {
  margin: 0;
  color: var(--troodon-c-text-high);
  font-size: var(--troodon-f-size-lg);
  font-weight: 700;
  line-height: var(--troodon-lh-button);
}

.c-error--404 {
  gap: 32px;
}

.c-error__note {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  background-color: var(--troodon-c-white);
  color: var(--troodon-c-text-high);
  font-size: var(--troodon-f-size-xs);
  font-weight: 400;
  line-height: var(--troodon-lh-annotation);
  text-align: left;
}

.c-error__note-label {
  margin: 0;
}

.c-error__note-list {
  margin: 0;
  padding-left: 18px;
}
</style>
